import ReactDOM from 'react-dom';
import App from 'components/app/App';
import 'index.css';
import 'dark.css';
import 'i18n';

ReactDOM.render(<App />, document.getElementById('root'));
